/** @file selectedQuad: the target part's drawn quad and handle points this frame (quads view, edit mode). */
import { quadEditOf } from './quadEditOf';
import { quadGeomOf, type QuadGeom } from './quadGeomOf';
import { quadHandlePoints } from './quadHandlePoints';
import { quadTarget } from './quadTarget';
import { rowOfDrawable } from './rowOfDrawable';
import type { ViewportCtx } from './viewportCtx';

/** The target drawable, its impostor row, its quad (a running drag or typed value applied) and the nine handle points (target px). */
export type SelectedQuad = { drawableIndex: number; impostor: number; geom: QuadGeom; points: [number, number][] };

/**
 * With the quads view on in edit mode: the part `quadTarget` names when it is drawn this frame (a running drag's own
 * part even if the selection moved); else null (no handles).
 */
export function selectedQuad(ctx: ViewportCtx): SelectedQuad | null {
  const puppet = ctx.puppet();
  if (ctx.mode !== 'edit' || puppet === null || ctx.scene === null || ctx.profile === null || !ctx.store.getState().camera.quads) return null;
  const drawableIndex = ctx.quad.edit?.drawableIndex ?? quadTarget(ctx);
  const state = puppet.instance.state();
  const i = rowOfDrawable(state.list, state.count, drawableIndex);
  if (i < 0) return null;
  const geom = quadGeomOf(state.list, i, ctx.scene.camera.contract(), ctx.profile, quadEditOf(ctx));
  return { drawableIndex, impostor: i, geom, points: quadHandlePoints(geom) };
}
